import React from 'react';
import Audio_Banner from '../../assets/goods/selling-product/audio-banner.webp';

export default function AudioBanner() {
  return (
    <section className="my-12">
      <div className="bg-white rounded-lg overflow-hidden shadow-md">
        <div className="relative h-[300px]">
          <img
            src={Audio_Banner}
            alt="Smart Home Experience"
            className="absolute w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex flex-col justify-center p-8 md:p-12">
            <div className="max-w-md p-6 rounded-lg shadow">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-900">
                Transform Your Home Experience
              </h2>
              <div className="flex space-x-4 mb-6">
                {[1, 2, 3, 4].map((num) => (
                  <div key={num} className="bg-gray-200 rounded-full w-10 h-10 flex items-center justify-center">
                    <span className="text-gray-800 font-medium">{num}</span>
                  </div>
                ))}
              </div>
              <button className="bg-[#ff9906] hover:bg-[#e68a00] text-white px-6 py-2 rounded-md transition-colors">
                Shop Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
